// Dependencies

import React, { Component } from "react"
import { Link } from "react-router-dom"

// Components

import Button from "../Button/Button"
import SocialMedia from "../SocialMedia/SocialMedia"

// Style

import "./navbar.css"

// Images

import calendar from "../images/calendar.svg"
import menuicon from "../images/menu-icon.svg"
import exitMenuIcon from "../images/exit-menu.svg"
import facebookIcon from "../images/facebook.svg"
import instagramIcon from "../images/instagram.svg"
import googleIcon from "../images/google-plus.svg"
import phone from "../images/support.svg"
import mail from "../images/mail.svg"

class Navbar extends React.Component {
  constructor(props) {
    super(props)

    this.state = { showMenu: false }

    this.iconClick = this.iconClick.bind(this)
    this.mobileLinkClick = this.mobileLinkClick.bind(this)
  }

  iconClick() {
    this.setState({
      showMenu: !this.state.showMenu,
    })
  }

  scrollToTop() {
    window.scrollTo(0, 0)
  }

  mobileLinkClick() {
    this.iconClick()
    window.scrollTo(0, 0)
  }

  render() {
    const menuVis = this.state.showMenu
      ? "navbar__mobile-menu-visible"
      : "navbar__mobile-menu-hidden"
    const menuIconChange = this.state.showMenu ? (
      <img
        alt="hamburger menu"
        onClick={this.iconClick}
        className="navbar__menu-icon"
        src={exitMenuIcon}
      />
    ) : (
      <img
        alt="hamburger menu"
        onClick={this.iconClick}
        className="navbar__menu-icon"
        src={menuicon}
      />
    )
    return (
      <div className="navbar-container">
        <div className={`${menuVis} navbar__mobile-menu`}>
          <Link to="/">
            <div
              role="link"
              onClick={this.mobileLinkClick}
              className="navbar__mobile-menu-link"
            >
              Home
            </div>
          </Link>
          <Link to="/fullmenu">
            <div
              role="link"
              onClick={this.mobileLinkClick}
              className="navbar__mobile-menu-link"
            >
              Menus
            </div>
          </Link>
          <Link to="/form">
            <div
              role="link"
              onClick={this.mobileLinkClick}
              className="navbar__mobile-menu-link"
            >
              Schedule Party
            </div>
          </Link>
          <div className="navbar__contact">
            <div className="navbar__icon-wrapper">
              <img
                alt="Contact Phone"
                className="navbar__contact-icon"
                src={phone}
              />
              <a href="tel:954-629-1046">954-629-1046</a>
            </div>

            <div className="navbar__icon-wrapper">
              <img
                alt="Contact Email"
                className="navbar__contact-icon"
                src={mail}
              />
              <a href="mailto:info@hibachiandyou.com">info@hibachiandyou.com</a>
            </div>
          </div>
          <SocialMedia />
        </div>
        <div className="navbar">
          <div className="navbar__desktop-social">
            <Button img={calendar} text="Schedule Party" link="form" />
            <SocialMedia />
          </div>
          <div className="navbar__desktop-links">
            <Link onClick={this.scrollToTop} to="/">
              <div className="navbar-desktop-link">Home</div>
            </Link>
            <Link onClick={this.scrollToTop} to="/fullmenu">
              <div className="navbar-desktop-link">Menus</div>
            </Link>
            <div className="navbar__desktop-phone">
              <div className="navbar__desktop-phone-icon">
                <img
                  alt="Contact Phone"
                  className="navbar__contact-icon"
                  src={phone}
                />
              </div>
              <a href="tel:954-629-1046">954-629-1046</a>
            </div>
          </div>
          {menuIconChange}
        </div>
      </div>
    )
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/navbar/navbar.js